import { render, staticRenderFns } from "./SaveChangesModal.vue?vue&type=template&id=7e2f401a"
import script from "./SaveChangesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaveChangesModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports